import { LeagueGenderValues } from '../../../../utils/eventConstants';

export const PLAYER_GENDERS = {
    MALE: 'Male',
    FEMALE: 'Female',
};

// Values that can appear in user.collegeCoachTeamGenders (any combination, or empty).
export const TEAM_GENDERS = {
    MALE: 'Male',
    FEMALE: 'Female',
    MIXED: 'Mixed',
};

export const RECRUITING_STATUS = {
    UNDECIDED: 1,
    ACTIVE: 2,
    COMMITTED: 3,
};

export const RECRUITING_STATUS_LABELS = {
    [RECRUITING_STATUS.UNDECIDED]: 'Undecided',
    [RECRUITING_STATUS.ACTIVE]: 'Active',
    [RECRUITING_STATUS.COMMITTED]: 'Committed',
};

// Exclusive recruiting-status filter values accepted by the prospects endpoint.
export const RECRUITING_STATUS_FILTER = {
    ALL: 'all',
    ACTIVE: 'active',
    COMMITTED: 'committed',
    UNDECIDED: 'undecided',
};

export const RECRUITING_STATUS_FILTER_LABELS = {
    [RECRUITING_STATUS_FILTER.ALL]: 'All Statuses',
    [RECRUITING_STATUS_FILTER.ACTIVE]: 'Active',
    [RECRUITING_STATUS_FILTER.COMMITTED]: 'Committed',
    [RECRUITING_STATUS_FILTER.UNDECIDED]: 'Undecided',
};

// RadioFilter uses `label` as the option's value and `description` as the visible text.
export const RECRUITING_STATUS_FILTER_OPTIONS = [
    { label: RECRUITING_STATUS_FILTER.ALL, description: RECRUITING_STATUS_FILTER_LABELS[RECRUITING_STATUS_FILTER.ALL] },
    { label: RECRUITING_STATUS_FILTER.ACTIVE, description: RECRUITING_STATUS_FILTER_LABELS[RECRUITING_STATUS_FILTER.ACTIVE] },
    { label: RECRUITING_STATUS_FILTER.COMMITTED, description: RECRUITING_STATUS_FILTER_LABELS[RECRUITING_STATUS_FILTER.COMMITTED] },
    { label: RECRUITING_STATUS_FILTER.UNDECIDED, description: RECRUITING_STATUS_FILTER_LABELS[RECRUITING_STATUS_FILTER.UNDECIDED] },
];

export const getRecruitingStatusFilterLabel = (value) => (
    RECRUITING_STATUS_FILTER_LABELS[value] || RECRUITING_STATUS_FILTER_LABELS[RECRUITING_STATUS_FILTER.ALL]
);

export const CPP_SORT_KEYS = {
    NAME: 'lastName',
    SINGLES_UTR: 'singlesUtr',
    DOUBLES_UTR: 'doublesUtr',
    GRAD_YEAR: 'gradYear',
};

export const getRecruitingStatusLabel = (cpp) => {
    if (!cpp) {
        return '';
    }
    return cpp.recruitingStatusLabel || RECRUITING_STATUS_LABELS[cpp.recruitingStatusId] || '';
};

export const canCoachAddPlayer = (collegeCoachTeamGenders, playerGender) => {
    if (!Array.isArray(collegeCoachTeamGenders) || collegeCoachTeamGenders.length === 0) {
        return false;
    }
    // A mixed (co-ed) team can recruit players of any gender.
    if (collegeCoachTeamGenders.includes(TEAM_GENDERS.MIXED)) {
        return true;
    }
    return collegeCoachTeamGenders.includes(playerGender);
};

// Default value for the gender filter, mapped to the filter's own values (LeagueGenderValues).
// Only pre-selects when the coach is restricted to a single player gender; men's + women's,
// mixed, or no teams leave the filter on "All".
export const getDefaultGenderFilter = (collegeCoachTeamGenders) => {
    const canAddMale = canCoachAddPlayer(collegeCoachTeamGenders, PLAYER_GENDERS.MALE);
    const canAddFemale = canCoachAddPlayer(collegeCoachTeamGenders, PLAYER_GENDERS.FEMALE);
    if (canAddMale && !canAddFemale) {
        return LeagueGenderValues.MALE;
    }
    if (canAddFemale && !canAddMale) {
        return LeagueGenderValues.FEMALE;
    }
    return null;
};
